import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Button } from '@gemini/ui';
import { serpViewIconMap, serpViewPaths } from '../../helpers/constants';
import { getQueryString } from '../../helpers/getQueryString';
import { useSerpTranslation } from '../../hooks/useI18n';
import { mapListButtonTrackingMedium } from '../../tracking/helpers';
export const SerpMapListButtonTestId = 'serp-map-list-button-test-id';
export const MapMapListButtonTestId = 'map-map-list-button-test-id';
export const MapListButton = ({ view, searchModel, order, page, defaultOrder }) => {
    const { t } = useSerpTranslation();
    const next = view === 'map' ? 'list' : 'map';
    return (
    // This box is needed to have a white background for the secondary button which is transparent
    _jsx(Box, { backgroundColor: "color.background.default", borderRadius: "radius.rounded", children: _jsx(Button, { href: `/${serpViewPaths[next]}?${getQueryString({ searchModel, order, page, trackingMedium: mapListButtonTrackingMedium[next] }, defaultOrder)}`, variant: "secondary-floating", icon: serpViewIconMap[next], iconPosition: "start", testId: view === 'map' ? MapMapListButtonTestId : SerpMapListButtonTestId, children: t(`header.quick_access.${next}`) }) }));
};
